<template>
  <EditCom
    title="新增图层分组导出任务"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import EditCom from '@/components/EditCom';

import {
  exportFavorite,
} from '@/api/ExportData';
// props
const props = defineProps({
  target: { type: Object, },
});
// emit
const emit = defineEmits([
  'close',
]);

const close = ()=>{
  emit('close');
}

const submitFn = (item, button, loadFn, fn)=>{
  exportFavorite({
    id: item['id'],
    // exportName: item['exportName'],
    type: 1,
  }).then(res=>{
    if(res.data.code == 1004){
      close();
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '图层分组', prop: 'id', type: 'select', 
    select: {
      list: 'favoriteList',
      label: 'name',
      value: 'id',
    }
  },
  // { name: '文件名称', prop: 'exportName', type: 'text', },
]);
const rules = reactive({
  id: [
    { required: true, message: '请选择图层分组', trigger: 'blur' },
  ],
  // exportName: [
  //   { required: true, message: '请输入文件名称', trigger: 'blur' },
  // ],
});

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>